module.exports = __webpack_public_path__ + "static/media/aws-redshift-logo.3bd1a0f9.svg";